'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SurveyModal = exports.SurveyModal = function () {
    function SurveyModal($body) {
        _classCallCheck(this, SurveyModal);

        this.$body = $body;
        this.$surveyModal = this.$body.find('.survey-modal');

        $body.trigger('startSurvey');

        this.bindEvents();
    }

    _createClass(SurveyModal, [{
        key: 'show',
        value: function show(callbackOnClose) {
            this.callbackOnClose = callbackOnClose;
            this.$surveyModal.modal();
        }
    }, {
        key: 'close',
        value: function close() {
            $.modal.close();
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _this = this;

            this.$surveyModal.on($.modal.CLOSE, function () {
                if (typeof _this.callbackOnClose === 'function') {
                    _this.callbackOnClose();
                    window.location.hash = 'start';
                }
            });
        }
    }]);

    return SurveyModal;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN1cnZleU1vZGFsLmpzIl0sIm5hbWVzIjpbIlN1cnZleU1vZGFsIiwiJGJvZHkiLCIkc3VydmV5TW9kYWwiLCJmaW5kIiwidHJpZ2dlciIsImJpbmRFdmVudHMiLCJjYWxsYmFja09uQ2xvc2UiLCJtb2RhbCIsIiQiLCJjbG9zZSIsIm9uIiwiQ0xPU0UiLCJ3aW5kb3ciLCJsb2NhdGlvbiIsImhhc2giXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7SUFBYUEsVyxXQUFBQSxXO0FBQ1QseUJBQVlDLEtBQVosRUFBbUI7QUFBQTs7QUFDZixhQUFLQSxLQUFMLEdBQWFBLEtBQWI7QUFDQSxhQUFLQyxZQUFMLEdBQW9CLEtBQUtELEtBQUwsQ0FBV0UsSUFBWCxDQUFnQixlQUFoQixDQUFwQjs7QUFFQUYsY0FBTUcsT0FBTixDQUFjLGFBQWQ7O0FBRUEsYUFBS0MsVUFBTDtBQUNIOzs7OzZCQUVJQyxlLEVBQWlCO0FBQ2xCLGlCQUFLQSxlQUFMLEdBQXVCQSxlQUF2QjtBQUNBLGlCQUFLSixZQUFMLENBQWtCSyxLQUFsQjtBQUNIOzs7Z0NBRU87QUFDSkMsY0FBRUQsS0FBRixDQUFRRSxLQUFSO0FBQ0g7OztxQ0FFWTtBQUFBOztBQUNULGlCQUFLUCxZQUFMLENBQWtCUSxFQUFsQixDQUFxQkYsRUFBRUQsS0FBRixDQUFRSSxLQUE3QixFQUFvQyxZQUFNO0FBQ3RDLG9CQUFJLE9BQU8sTUFBS0wsZUFBWixLQUFnQyxVQUFwQyxFQUFnRDtBQUM1QywwQkFBS0EsZUFBTDtBQUNBTSwyQkFBT0MsUUFBUCxDQUFnQkMsSUFBaEIsR0FBdUIsT0FBdkI7QUFDSDtBQUNKLGFBTEQ7QUFNSCIsImZpbGUiOiJzdXJ2ZXlNb2RhbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjbGFzcyBTdXJ2ZXlNb2RhbCB7XG4gICAgY29uc3RydWN0b3IoJGJvZHkpIHtcbiAgICAgICAgdGhpcy4kYm9keSA9ICRib2R5O1xuICAgICAgICB0aGlzLiRzdXJ2ZXlNb2RhbCA9IHRoaXMuJGJvZHkuZmluZCgnLnN1cnZleS1tb2RhbCcpO1xuXG4gICAgICAgICRib2R5LnRyaWdnZXIoJ3N0YXJ0U3VydmV5Jyk7XG5cbiAgICAgICAgdGhpcy5iaW5kRXZlbnRzKCk7XG4gICAgfVxuXG4gICAgc2hvdyhjYWxsYmFja09uQ2xvc2UpIHtcbiAgICAgICAgdGhpcy5jYWxsYmFja09uQ2xvc2UgPSBjYWxsYmFja09uQ2xvc2U7XG4gICAgICAgIHRoaXMuJHN1cnZleU1vZGFsLm1vZGFsKCk7XG4gICAgfVxuXG4gICAgY2xvc2UoKSB7XG4gICAgICAgICQubW9kYWwuY2xvc2UoKTtcbiAgICB9XG5cbiAgICBiaW5kRXZlbnRzKCkge1xuICAgICAgICB0aGlzLiRzdXJ2ZXlNb2RhbC5vbigkLm1vZGFsLkNMT1NFLCAoKSA9PiB7XG4gICAgICAgICAgICBpZiAodHlwZW9mIHRoaXMuY2FsbGJhY2tPbkNsb3NlID09PSAnZnVuY3Rpb24nKSB7XG4gICAgICAgICAgICAgICAgdGhpcy5jYWxsYmFja09uQ2xvc2UoKTtcbiAgICAgICAgICAgICAgICB3aW5kb3cubG9jYXRpb24uaGFzaCA9ICdzdGFydCc7XG4gICAgICAgICAgICB9XG4gICAgICAgIH0pO1xuICAgIH1cbn0iXX0=